import { globalSettings, isUndNullEmp, responseGet, welcomenMessage02Get } from '../../helpers/settings';

//#region old code
// const images?.img001 = `${backend?.url}/images/93491522393929597.png`;
// const images?.img002 = `${backend?.url}/images/appLogo52x52.png`;
// const images?.facebook = `${backend?.url}/images/facebook-circle-white.png`;
// const images?.twitter = `${backend?.url}/images/twitter-circle-white.png`;
// const images?.instagram = `${backend?.url}/images/instagram-circle-white.png`;
// const images?.linkedin = `${backend?.url}/images/linkedin-circle-white.png`;
//#endregion old code

//#region old code
// const urls?.facebook = 'https://www.facebook.com/VzLaCondominios';
// //const urls?.twitter = 'https://twitter.com/VzLaCondominios';
// const urls?.twitter = 'https://twitter.com/VzLaCondominio';
// const urls?.instagram = 'https://www.instagram.com/VzLaCondominios';
// const urls?.linkedin = 'https://www.linkedin.com/VzLaCondominios';
//#endregion old code

const { app, labels, messages, } = globalSettings;
const { backend, } = app;

const images = {
  img001: `${backend?.url}/images/93491522393929597.png`,
  img002: `${backend?.url}/images/appLogo52x52.png`,
  facebook: `${backend?.url}/images/facebook-circle-white.png`,
  twitter: `${backend?.url}/images/twitter-circle-white.png`,
  instagram: `${backend?.url}/images/instagram-circle-white.png`,
  linkedin: `${backend?.url}/images/linkedin-circle-white.png`,
};

const urls = {
  facebook: 'https://www.facebook.com/VzLaCondominios',
  //witter: 'https://twitter.com/VzLaCondominios',
  twitter: 'https://twitter.com/VzLaCondominio',
  instagram: 'https://www.instagram.com/VzLaCondominios',
  linkedin: 'https://www.linkedin.com/VzLaCondominios',
};

const appData = {
  title: app?.title,
  year: app?.year,
  address: app?.address,
  email: app?.emails?.primary,
  appVersion: app?.version,
};

export const welcomeMessageEmailBodyGet = ({
  userId = '',
  firstName = '',
  lastName = '',
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'welcomeMessageEmailBodyGet';
  let response = responseGet();
  try {
    //#region variables
    const fullName = `${firstName}${isUndNullEmp({ data: lastName, subMethod: currentMethod, })?.result ? "" : `, ${lastName}`}`;
    //#endregion variables

    //#region get html file
    response.result = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
        <html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
          <head>
            <meta charset="UTF-8">
            <meta content="width=device-width, initial-scale=1" name="viewport">
            <meta name="x-apple-disable-message-reformatting">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <meta content="telephone=no" name="format-detection">
            <title>New email template 2022-06-24</title>
            <!--[if (mso 16)]>
            <style type="text/css">
            a {text-decoration: none;}
            </style>
            <![endif]-->
            <!--[if gte mso 9]>
            <style>sup { font-size: 100% !important; }</style>
            <![endif]-->
            <!--[if gte mso 9]>
            <xml>
            <o:OfficeDocumentSettings>
            <o:AllowPNG></o:AllowPNG>
            <o:PixelsPerInch>96</o:PixelsPerInch>
            </o:OfficeDocumentSettings>
            </xml>
            <![endif]-->
            <!--[if !mso]>
            -->
            <link href="https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i" rel="stylesheet">
            <!--
            <![endif]-->
            <style type="text/css">
              #outlook a {
                padding: 0;
              }
        
              .ExternalClass {
                width: 100%;
              }
        
              .ExternalClass,
              .ExternalClass p,
              .ExternalClass span,
              .ExternalClass font,
              .ExternalClass td,
              .ExternalClass div {
                line-height: 100%;
              }
        
              .es-button {
                mso-style-priority: 100 !important;
                text-decoration: none !important;
                transition: all 100ms ease-in;
              }
        
              a[x-apple-data-detectors] {
                color: inherit !important;
                text-decoration: none !important;
                font-size: inherit !important;
                font-family: inherit !important;
                font-weight: inherit !important;
                line-height: inherit !important;
              }
        
              .es-button:hover {
                background: #555555 !important;
                border-color: #555555 !important;
              }
        
              .es-desk-hidden {
                display: none;
                float: left;
                overflow: hidden;
                width: 0;
                max-height: 0;
                line-height: 0;
                mso-hide: all;
              }
        
              [data-ogsb] .es-button {
                border-width: 0 !important;
                padding: 15px 30px 15px 30px !important;
              }
        
              [data-ogsb] .es-button.es-button-1 {
                padding: 15px 25px !important;
              }
        
              @media only screen and (max-width:600px) {
        
                p,
                ul li,
                ol li,
                a {
                  line-height: 150% !important
                }
        
                h1,
                h2,
                h3,
                h1 a,
                h2 a,
                h3 a {
                  line-height: 120% !important
                }
        
                h1 {
                  font-size: 30px !important;
                  text-align: center
                }
        
                h2 {
                  font-size: 26px !important;
                  text-align: left
                }
        
                h3 {
                  font-size: 20px !important;
                  text-align: left
                }
        
                h1 a {
                  text-align: center
                }
        
                .es-header-body h1 a,
                .es-content-body h1 a,
                .es-footer-body h1 a {
                  font-size: 30px !important
                }
        
                h2 a {
                  text-align: left
                }
        
                .es-header-body h2 a,
                .es-content-body h2 a,
                .es-footer-body h2 a {
                  font-size: 20px !important
                }
        
                h3 a {
                  text-align: left
                }
        
                .es-header-body h3 a,
                .es-content-body h3 a,
                .es-footer-body h3 a {
                  font-size: 20px !important
                }
        
                .es-menu td a {
                  font-size: 16px !important
                }
        
                .es-header-body p,
                .es-header-body ul li,
                .es-header-body ol li,
                .es-header-body a {
                  font-size: 16px !important
                }
        
                .es-content-body p,
                .es-content-body ul li,
                .es-content-body ol li,
                .es-content-body a {
                  font-size: 17px !important
                }
        
                .es-footer-body p,
                .es-footer-body ul li,
                .es-footer-body ol li,
                .es-footer-body a {
                  font-size: 17px !important
                }
        
                .es-infoblock p,
                .es-infoblock ul li,
                .es-infoblock ol li,
                .es-infoblock a {
                  font-size: 12px !important
                }
        
                *[class="gmail-fix"] {
                  display: none !important
                }
        
                .es-m-txt-c,
                .es-m-txt-c h1,
                .es-m-txt-c h2,
                .es-m-txt-c h3 {
                  text-align: center !important
                }
        
                .es-m-txt-r,
                .es-m-txt-r h1,
                .es-m-txt-r h2,
                .es-m-txt-r h3 {
                  text-align: right !important
                }
        
                .es-m-txt-l,
                .es-m-txt-l h1,
                .es-m-txt-l h2,
                .es-m-txt-l h3 {
                  text-align: left !important
                }
        
                .es-m-txt-r img,
                .es-m-txt-c img,
                .es-m-txt-l img {
                  display: inline !important
                }
        
                .es-button-border {
                  display: inline-block !important
                }
        
                a.es-button,
                button.es-button {
                  font-size: 14px !important;
                  display: inline-block !important;
                  border-width: 15px 25px 15px 25px !important
                }
        
                .es-btn-fw {
                  border-width: 10px 0px !important;
                  text-align: center !important
                }
        
                .es-adaptive table,
                .es-btn-fw,
                .es-btn-fw-brdr,
                .es-left,
                .es-right {
                  width: 100% !important
                }
        
                .es-content table,
                .es-header table,
                .es-footer table,
                .es-content,
                .es-footer,
                .es-header {
                  width: 100% !important;
                  max-width: 600px !important
                }
        
                .es-adapt-td {
                  display: block !important;
                  width: 100% !important
                }
        
                .adapt-img {
                  width: 100% !important;
                  height: auto !important
                }
        
                .es-m-p0 {
                  padding: 0px !important
                }
        
                .es-m-p0r {
                  padding-right: 0px !important
                }
        
                .es-m-p0l {
                  padding-left: 0px !important
                }
        
                .es-m-p0t {
                  padding-top: 0px !important
                }
        
                .es-m-p0b {
                  padding-bottom: 0 !important
                }
        
                .es-m-p20b {
                  padding-bottom: 20px !important
                }
        
                .es-mobile-hidden,
                .es-hidden {
                  display: none !important
                }
        
                tr.es-desk-hidden,
                td.es-desk-hidden,
                table.es-desk-hidden {
                  width: auto !important;
                  overflow: visible !important;
                  float: none !important;
                  max-height: inherit !important;
                  line-height: inherit !important
                }
        
                tr.es-desk-hidden {
                  display: table-row !important
                }
        
                table.es-desk-hidden {
                  display: table !important
                }
        
                td.es-desk-menu-hidden {
                  display: table-cell !important
                }
        
                .es-menu td {
                  width: 1% !important
                }
        
                table.es-table-not-adapt,
                .esd-block-html table {
                  width: auto !important
                }
        
                table.es-social {
                  display: inline-block !important
                }
        
                table.es-social td {
                  display: inline-block !important
                }
        
                .es-desk-hidden {
                  display: table-row !important;
                  width: auto !important;
                  overflow: visible !important;
                  max-height: inherit !important
                }
              }
            </style>
          </head>
          <body style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
            <div class="es-wrapper-color" style="background-color:#F1F1F1">
                <!--[if gte mso 9]>
                <v:background
                xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
                <v:fill type="tile" color="#f1f1f1"></v:fill>
                </v:background>
                <![endif]-->
              <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
                <tbody>
                  <tr style="border-collapse:collapse">
                    <td valign="top" style="padding:0;Margin:0">
                      <table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
                                        <!--[if mso]>
                                        <table style="width:580px" cellpadding="0" cellspacing="0">
                                        <tr>
                                        <td style="width:282px" valign="top">
                                        <![endif]-->
                                      <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td align="left" style="padding:0;Margin:0;width:282px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">
                                                        <br>
                                                      </p>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                        <!--[if mso]>
                                        </td>
                                        <td style="width:20px"></td>
                                        <td style="width:278px" valign="top">
                                        <![endif]-->
                                      <table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td align="left" style="padding:0;Margin:0;width:278px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">
                                                        <!--<a href="${app?.url}${backend?.urlWelcomeMessage}/${userId}" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">${messages?.viewInBrowser?.[languageId]}</a>-->
                                                      </p>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                        <!--[if mso]>
                                        </td>
                                        </tr>
                                        </table>
                                        <![endif]-->
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-header" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px;background-color:#333333" bgcolor="#333333" align="left">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;font-size:0">
                                                      <!--<a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#FFFFFF;font-size:14px">-->
                                                      <a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px">
                                                        <!--<img src="https://vlckba.stripocdn.email/content/guids/CABINET_85e4431b39e3c4492fca561009cef9b5/images/51621521206431413.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="57">-->
                                                        <h3 style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:15px;font-style:normal;font-weight:bold;color:#ffffff">${appData?.title}</h3>
                                                      </a>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#333333;width:600px" cellspacing="0" cellpadding="0" bgcolor="#333333" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px;background-image:url('${images?.img001}');background-repeat:no-repeat" align="left" background="${images?.img001}">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;padding-bottom:10px;padding-top:40px">
                                                      <h1 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#ffffff">${labels?.welcomeTwo?.[languageId]} ${fullName}</h1>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td esdev-links-color="#757575" align="center" style="Margin:0;padding-top:10px;padding-bottom:20px;padding-left:30px;padding-right:30px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#757575;font-size:15px">${messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageId]}.</p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:20px">
                                                      <span class="es-button-border" style="border-style:solid;border-color:#26a4d3;background:none 0% 0% repeat scroll #26a4d3;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                        <a href="${app?.url}${backend?.urlLogin}" class="es-button" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;border-style:solid;border-color:#26a4d3;border-width:15px 30px 15px 30px;display:inline-block;background:#26a4d3;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${labels?.accessAccount?.[languageId]}</a>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td align="left" style="padding:0;Margin:0;padding-top:40px;padding-left:40px;padding-right:40px">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td class="es-m-txt-c" align="left" style="padding:0;Margin:0;padding-top:5px;padding-bottom:15px">
                                                      <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#333333">${messages?.yourAccountIsNowActivate?.[languageId]}</h2>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="left" style="padding:0;Margin:0;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                        <!--<strong>${messages?.welcomeMessage01?.[languageId]}.</strong>-->
                                                        ${messages?.welcomeMessage01?.[languageId]}.
                                                      </p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${welcomenMessage02Get({ languageId: languageId, subMethod: currentMethod, })?.result}. <br>
                                                      </p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${labels?.yoursSincerely?.[languageId]},</p>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                  <tr style="border-collapse:collapse">
                                    <td align="left" style="Margin:0;padding-top:10px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                        <!--[if mso]>
                                        <table style="width:520px" cellpadding="0"
                                        cellspacing="0">
                                        <tr>
                                        <td style="width:40px" valign="top">
                                        <![endif]-->
                                      <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:40px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="left" style="padding:0;Margin:0;font-size:0">
                                                      <img src="${images?.img002}" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="50">
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                        <!--[if mso]>
                                        </td>
                                        <td style="width:20px"></td>
                                        <td style="width:460px" valign="top">
                                        <![endif]-->
                                      <table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td align="left" style="padding:0;Margin:0;width:460px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                      <td align="left" style="padding:0;Margin:0;padding-top:10px">
                                                        <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#222222;font-size:14px">
                                                          <strong>${app?.ceo}</strong>
                                                          <br>
                                                        </p>
                                                      </td>
                                                    </tr>
                                                    <tr style="border-collapse:collapse">
                                                      <td align="left" style="padding:0;Margin:0">
                                                        <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#666666;font-size:14px">CEO | ${appData?.title}</p>
                                                      </td>
                                                    </tr>
                                                </tbody> 
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                        <!--[if mso]>
                                        </td>
                                        </tr>
                                        </table>
                                        <![endif]-->
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#26a4d3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#26a4d3" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td style="Margin:0;padding-bottom:20px;padding-top:40px;padding-left:40px;padding-right:40px;background-color:#26a4d3" bgcolor="#26a4d3" align="left">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td class="es-m-txt-c" align="center" style="padding:0;Margin:0">
                                                      <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#ffffff">${messages?.yourFeedbackIsImportant?.[languageId]} <br>
                                                      </h2>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;padding-top:5px;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:26px;color:#aad4ea;font-size:17px">${messages?.letUsKnowWhatYouThinkOfOurLatestUpdates?.[languageId]} <br>
                                                      </p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:10px;Margin:0">
                                                      <span class="es-button-border" style="border-style:solid;border-color:#26A4D3;background:#ffffff;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                        <a href="${app?.url}${backend?.urlContact}" class="es-button es-button-1" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#26a4d3;font-size:14px;border-style:solid;border-color:#ffffff;border-width:15px 25px;display:inline-block;background:#ffffff;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${messages?.giveFeedback?.[languageId]}</a>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#292828;width:600px" cellspacing="0" cellpadding="0" bgcolor="#292828" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td align="left" style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;font-size:0">
                                                      <table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                        <tbody>
                                                          <tr style="border-collapse:collapse">
                                                            <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                              <a href='${urls?.facebook}' target='_blank'>
                                                                <img title="Facebook" src="${images?.facebook}" alt="Fb" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                              </a>
                                                            </td>
                                                            <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                              <a href='${urls?.twitter}' target='_blank'>
                                                                <img title="Twitter" src="${images?.twitter}" alt="Tw" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                              </a>
                                                            </td>
                                                            <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                              <a href='${urls?.instagram}' target='_blank'>
                                                                <img title="Instagram" src="${images?.instagram}" alt="Inst" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                              </a>
                                                            </td>
                                                            <td valign="top" align="center" style="padding:0;Margin:0">
                                                              <a href='${urls?.linkedin}' target='_blank'>
                                                                <img title="Linkedin" src="${images?.linkedin}" alt="In" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                              </a>
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-footer" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-footer-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td align="left" style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${appData?.address}</p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${messages?.thisEmailWasSentToYouFrom?.[languageId]} ${appData?.email}</p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">
                                                        <a target="_blank" href="${app?.url}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.home?.[languageId]}</a> | <a target="_blank" href="${app?.url}/about" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.about?.[languageId]}</a> | <a target="_blank" href="${app?.url}${backend?.urlContact}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.contact?.[languageId]}</a> | <a target="_blank" class="unsubscribe" href="${app?.url}/privacy" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.privacy?.[languageId]}</a>
                                                      </p>
                                                    </td>
                                                  </tr>
                                                  <tr style="border-collapse:collapse">
                                                    <td align="center" style="padding:0;Margin:0">
                                                      <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">Copyright © ${appData?.year} <strong>${appData?.title}</strong>, All Rights Reserved. </p>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                        <tbody>
                          <tr style="border-collapse:collapse">
                            <td align="center" style="padding:0;Margin:0">
                              <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                                <tbody>
                                  <tr style="border-collapse:collapse">
                                    <td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
                                      <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                        <tbody>
                                          <tr style="border-collapse:collapse">
                                            <td valign="top" align="center" style="padding:0;Margin:0;width:560px">
                                              <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                <tbody>
                                                  <tr style="border-collapse:collapse">
                                                    <td class="es-infoblock made_with" align="center" style="padding:0;Margin:0;line-height:120%;font-size:0;color:#CCCCCC"></td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </body>
        </html>`;
    //#endregion get html file
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const verificationEmailBodyGet = ({
  userId = '',
  firstName = '',
  lastName = '',
  urlVerificationEmail = '',
  languageId = 'en',
  subMethod = '',
}) => {
  let response = responseGet();
  const currentMethod = 'verificationEmailBodyGet';
  try {
    //#region variables
    const fullName = `${firstName}${(isUndNullEmp({ data: lastName, subMethod: currentMethod, })?.result) ? "" : `, ${lastName}`}`;
    //#endregion variables

    //#region get html file
    response.result = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
          <html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
          <head>
              <meta charset="UTF-8">
              <meta content="width=device-width, initial-scale=1" name="viewport">
              <meta name="x-apple-disable-message-reformatting">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta content="telephone=no" name="format-detection">
              <title>New email template 2022-06-24</title>
              <!--[if (mso 16)]>
                                      <style type="text/css">
              a {text-decoration: none;}
              </style>
                                      <![endif]-->
              <!--[if gte mso 9]>
                                      <style>sup { font-size: 100% !important; }</style>
                                      <![endif]-->
              <!--[if gte mso 9]>
                                      <xml>
                                          <o:OfficeDocumentSettings>
                                              <o:AllowPNG></o:AllowPNG>
                                              <o:PixelsPerInch>96</o:PixelsPerInch>
                                          </o:OfficeDocumentSettings>
                                      </xml>
                                      <![endif]-->
              <!--[if !mso]>
                                      <!-- -->
              <link href="https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i" rel="stylesheet">
              <!--
                                          <![endif]-->
              <style type="text/css">
              #outlook a {
                  padding: 0;
              }

              .ExternalClass {
                  width: 100%;
              }

              .ExternalClass,
              .ExternalClass p,
              .ExternalClass span,
              .ExternalClass font,
              .ExternalClass td,
              .ExternalClass div {
                  line-height: 100%;
              }

              .es-button {
                  mso-style-priority: 100 !important;
                  text-decoration: none !important;
                  transition: all 100ms ease-in;
              }

              a[x-apple-data-detectors] {
                  color: inherit !important;
                  text-decoration: none !important;
                  font-size: inherit !important;
                  font-family: inherit !important;
                  font-weight: inherit !important;
                  line-height: inherit !important;
              }

              .es-button:hover {
                  background: #555555 !important;
                  border-color: #555555 !important;
              }

              .es-desk-hidden {
                  display: none;
                  float: left;
                  overflow: hidden;
                  width: 0;
                  max-height: 0;
                  line-height: 0;
                  mso-hide: all;
              }

              [data-ogsb] .es-button {
                  border-width: 0 !important;
                  padding: 15px 30px 15px 30px !important;
              }

              [data-ogsb] .es-button.es-button-1 {
                  padding: 15px 25px !important;
              }

              @media only screen and (max-width:600px) {

                  p,
                  ul li,
                  ol li,
                  a {
                  line-height: 150% !important
                  }

                  h1,
                  h2,
                  h3,
                  h1 a,
                  h2 a,
                  h3 a {
                  line-height: 120% !important
                  }

                  h1 {
                  font-size: 30px !important;
                  text-align: center
                  }

                  h2 {
                  font-size: 26px !important;
                  text-align: left
                  }

                  h3 {
                  font-size: 20px !important;
                  text-align: left
                  }

                  h1 a {
                  text-align: center
                  }

                  .es-header-body h1 a,
                  .es-content-body h1 a,
                  .es-footer-body h1 a {
                  font-size: 30px !important
                  }

                  h2 a {
                  text-align: left
                  }

                  .es-header-body h2 a,
                  .es-content-body h2 a,
                  .es-footer-body h2 a {
                  font-size: 20px !important
                  }

                  h3 a {
                  text-align: left
                  }

                  .es-header-body h3 a,
                  .es-content-body h3 a,
                  .es-footer-body h3 a {
                  font-size: 20px !important
                  }

                  .es-menu td a {
                  font-size: 16px !important
                  }

                  .es-header-body p,
                  .es-header-body ul li,
                  .es-header-body ol li,
                  .es-header-body a {
                  font-size: 16px !important
                  }

                  .es-content-body p,
                  .es-content-body ul li,
                  .es-content-body ol li,
                  .es-content-body a {
                  font-size: 17px !important
                  }

                  .es-footer-body p,
                  .es-footer-body ul li,
                  .es-footer-body ol li,
                  .es-footer-body a {
                  font-size: 17px !important
                  }

                  .es-infoblock p,
                  .es-infoblock ul li,
                  .es-infoblock ol li,
                  .es-infoblock a {
                  font-size: 12px !important
                  }

                  *[class="gmail-fix"] {
                  display: none !important
                  }

                  .es-m-txt-c,
                  .es-m-txt-c h1,
                  .es-m-txt-c h2,
                  .es-m-txt-c h3 {
                  text-align: center !important
                  }

                  .es-m-txt-r,
                  .es-m-txt-r h1,
                  .es-m-txt-r h2,
                  .es-m-txt-r h3 {
                  text-align: right !important
                  }

                  .es-m-txt-l,
                  .es-m-txt-l h1,
                  .es-m-txt-l h2,
                  .es-m-txt-l h3 {
                  text-align: left !important
                  }

                  .es-m-txt-r img,
                  .es-m-txt-c img,
                  .es-m-txt-l img {
                  display: inline !important
                  }

                  .es-button-border {
                  display: inline-block !important
                  }

                  a.es-button,
                  button.es-button {
                  font-size: 14px !important;
                  display: inline-block !important;
                  border-width: 15px 25px 15px 25px !important
                  }

                  .es-btn-fw {
                  border-width: 10px 0px !important;
                  text-align: center !important
                  }

                  .es-adaptive table,
                  .es-btn-fw,
                  .es-btn-fw-brdr,
                  .es-left,
                  .es-right {
                  width: 100% !important
                  }

                  .es-content table,
                  .es-header table,
                  .es-footer table,
                  .es-content,
                  .es-footer,
                  .es-header {
                  width: 100% !important;
                  max-width: 600px !important
                  }

                  .es-adapt-td {
                  display: block !important;
                  width: 100% !important
                  }

                  .adapt-img {
                  width: 100% !important;
                  height: auto !important
                  }

                  .es-m-p0 {
                  padding: 0px !important
                  }

                  .es-m-p0r {
                  padding-right: 0px !important
                  }

                  .es-m-p0l {
                  padding-left: 0px !important
                  }

                  .es-m-p0t {
                  padding-top: 0px !important
                  }

                  .es-m-p0b {
                  padding-bottom: 0 !important
                  }

                  .es-m-p20b {
                  padding-bottom: 20px !important
                  }

                  .es-mobile-hidden,
                  .es-hidden {
                  display: none !important
                  }

                  tr.es-desk-hidden,
                  td.es-desk-hidden,
                  table.es-desk-hidden {
                  width: auto !important;
                  overflow: visible !important;
                  float: none !important;
                  max-height: inherit !important;
                  line-height: inherit !important
                  }

                  tr.es-desk-hidden {
                  display: table-row !important
                  }

                  table.es-desk-hidden {
                  display: table !important
                  }

                  td.es-desk-menu-hidden {
                  display: table-cell !important
                  }

                  .es-menu td {
                  width: 1% !important
                  }

                  table.es-table-not-adapt,
                  .esd-block-html table {
                  width: auto !important
                  }

                  table.es-social {
                  display: inline-block !important
                  }

                  table.es-social td {
                  display: inline-block !important
                  }

                  .es-desk-hidden {
                  display: table-row !important;
                  width: auto !important;
                  overflow: visible !important;
                  max-height: inherit !important
                  }
              }
              </style>
          </head>
          <body style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
              <div class="es-wrapper-color" style="background-color:#F1F1F1">
              <!--[if gte mso 9]>
                                              <v:background
                                                  xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
                                                  <v:fill type="tile" color="#f1f1f1"></v:fill>
                                              </v:background>
                                              <![endif]-->
              <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
                  <tr style="border-collapse:collapse">
                  <td valign="top" style="padding:0;Margin:0">
                      <table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
                                  <!--[if mso]>
                                                                                  <table style="width:580px" cellpadding="0" cellspacing="0">
                                                                                      <tr>
                                                                                          <td style="width:282px" valign="top">
                                                                                              <![endif]-->
                                  <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:282px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px"><br>
                                              </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                              </td>
                                                                                              <td style="width:20px"></td>
                                                                                              <td style="width:278px" valign="top">
                                                                                                  <![endif]-->
                                  <table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:278px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">
                                                  <!--<a href="${app?.url}${backend?.urlVerificationMessage}/${userId}" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">${messages?.viewInBrowser?.[languageId]}</a>-->
                                              </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                              </td>
                                                                                          </tr>
                                                                                      </table>
                                                                                      <![endif]-->
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-header" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px;background-color:#333333" bgcolor="#333333" align="left">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;font-size:0">
                                              <!--<a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#FFFFFF;font-size:14px">-->
                                              <a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px">
                                              <!--<img src="https://vlckba.stripocdn.email/content/guids/CABINET_85e4431b39e3c4492fca561009cef9b5/images/51621521206431413.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="57">-->
                                              <h3 style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:15px;font-style:normal;font-weight:bold;color:#ffffff">${appData?.title}</h3>
                                              </a>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#333333;width:600px" cellspacing="0" cellpadding="0" bgcolor="#333333" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px;background-image:url('${images?.img001}');background-repeat:no-repeat" align="left" background="${images?.img001}">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px;padding-top:40px">
                                              <h1 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#ffffff">${labels?.hello?.[languageId]} ${fullName}</h1>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td esdev-links-color="#757575" align="center" style="Margin:0;padding-top:10px;padding-bottom:20px;padding-left:30px;padding-right:30px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#757575;font-size:15px">${messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageId]}.</p>
                                          </td>
                                          </tr>
                                          <!--<tr style="border-collapse:collapse">
                                              <td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:20px">
                                                  <span class="es-button-border" style="border-style:solid;border-color:#26a4d3;background:none 0% 0% repeat scroll #26a4d3;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                  <a href="${app?.url}${backend?.urlLogin}" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;border-style:solid;border-color:#26a4d3;border-width:15px 30px 15px 30px;display:inline-block;background:#26a4d3;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${labels?.accessAccount?.[languageId]}</a>
                                                  </span>
                                              </td>
                                          </tr>-->
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="padding:0;Margin:0;padding-top:40px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-m-txt-c" align="left" style="padding:0;Margin:0;padding-top:5px;padding-bottom:15px">
                                              <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#333333">${messages?.yourAccountIsAlmostActive?.[languageId]}</h2>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                  ${messages?.verificationMessage01?.[languageId]}.
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                              <td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:20px">
                                                  <span class="es-button-border" style="border-style:solid;border-color:#26a4d3;background:none 0% 0% repeat scroll #26a4d3;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                  <a href="${urlVerificationEmail}" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;border-style:solid;border-color:#26a4d3;border-width:15px 30px 15px 30px;display:inline-block;background:#26a4d3;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${labels?.verifyAccount?.[languageId]}</a>
                                                  </span>
                                              </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${welcomenMessage02Get({ languageId: languageId, subMethod: currentMethod, })?.result}. <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${labels?.yoursSincerely?.[languageId]},</p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:10px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                  <!--[if mso]>
                                                                                              <table style="width:520px" cellpadding="0"
                                      cellspacing="0">
                                                                                                  <tr>
                                                                                                      <td style="width:40px" valign="top">
                                                                                                          <![endif]-->
                                  <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                  <tr style="border-collapse:collapse">
                                      <td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:40px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;font-size:0">
                                              <img src="${images?.img002}" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="50">
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                                          </td>
                                                                                                          <td style="width:20px"></td>
                                                                                                          <td style="width:460px" valign="top">
                                                                                                              <![endif]-->
                                  <table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:460px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#222222;font-size:14px">
                                              <strong>${app?.ceo}</strong>
                                              <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#666666;font-size:14px">CEO | ${appData?.title}</p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                                              </td>
                                                                                                          </tr>
                                                                                                      </table>
                                                                                                      <![endif]-->
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#26a4d3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#26a4d3" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-bottom:20px;padding-top:40px;padding-left:40px;padding-right:40px;background-color:#26a4d3" bgcolor="#26a4d3" align="left">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-m-txt-c" align="center" style="padding:0;Margin:0">
                                              <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#ffffff">${messages?.yourFeedbackIsImportant?.[languageId]} <br>
                                              </h2>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-top:5px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:26px;color:#aad4ea;font-size:17px">${messages?.letUsKnowWhatYouThinkOfOurLatestUpdates?.[languageId]} <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:10px;Margin:0">
                                              <span class="es-button-border" style="border-style:solid;border-color:#26A4D3;background:#ffffff;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                              <a href="${app?.url}${backend?.urlContact}" class="es-button es-button-1" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#26a4d3;font-size:14px;border-style:solid;border-color:#ffffff;border-width:15px 25px;display:inline-block;background:#ffffff;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${messages?.giveFeedback?.[languageId]}</a>
                                              </span>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#292828;width:600px" cellspacing="0" cellpadding="0" bgcolor="#292828" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;font-size:0">
                                              <table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                              <tr style="border-collapse:collapse">
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.facebook}' target='_blank'>
                                                          <img title="Facebook" src="${images?.facebook}" alt="Fb" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.twitter}' target='_blank'>
                                                          <img title="Twitter" src="${images?.twitter}" alt="Tw" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.instagram}' target='_blank'>
                                                          <img title="Instagram" src="${images?.instagram}" alt="Inst" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0">
                                                      <a href='${urls?.linkedin}' target='_blank'>
                                                          <img title="Linkedin" src="${images?.linkedin}" alt="In" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                              </tr>
                                              </table>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-footer" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-footer-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${appData?.address}</p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${messages?.thisEmailWasSentToYouFrom?.[languageId]} ${appData?.email}</p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">
                                              <a target="_blank" href="${app?.url}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.home?.[languageId]}</a> | <a target="_blank" href="${app?.url}/about" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.about?.[languageId]}</a> | <a target="_blank" href="${app?.url}${backend?.urlContact}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.contact?.[languageId]}</a> | <a target="_blank" class="unsubscribe" href="${app?.url}/privacy" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.privacy?.[languageId]}</a>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">Copyright © ${appData?.year} <strong>${appData?.title}</strong>, All Rights Reserved. </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:560px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-infoblock made_with" align="center" style="padding:0;Margin:0;line-height:120%;font-size:0;color:#CCCCCC">
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                  </td>
                  </tr>
              </table>
              </div>
          </body>
          </html>`;
    //#endregion get html file
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const forgotPasswordEmailBodyGet = ({
  userId = '',
  firstName = '',
  lastName = '',
  urlForgotPassword = '',
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'forgotPasswordEmailBodyGet';
  let response = responseGet();
  try {
    //#region variables
    const fullName = `${firstName}${(isUndNullEmp({ data: lastName, subMethod: currentMethod, })?.result) ? "" : `, ${lastName}`}`;
    //#endregion variables

    //#region get html file
    response.result = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
          <html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
          <head>
              <meta charset="UTF-8">
              <meta content="width=device-width, initial-scale=1" name="viewport">
              <meta name="x-apple-disable-message-reformatting">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta content="telephone=no" name="format-detection">
              <title>New email template 2022-06-24</title>
              <!--[if (mso 16)]>
                                      <style type="text/css">
              a {text-decoration: none;}
              </style>
                                      <![endif]-->
              <!--[if gte mso 9]>
                                      <style>sup { font-size: 100% !important; }</style>
                                      <![endif]-->
              <!--[if gte mso 9]>
                                      <xml>
                                          <o:OfficeDocumentSettings>
                                              <o:AllowPNG></o:AllowPNG>
                                              <o:PixelsPerInch>96</o:PixelsPerInch>
                                          </o:OfficeDocumentSettings>
                                      </xml>
                                      <![endif]-->
              <!--[if !mso]>
                                      <!-- -->
              <link href="https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i" rel="stylesheet">
              <!--
                                          <![endif]-->
              <style type="text/css">
              #outlook a {
                  padding: 0;
              }

              .ExternalClass {
                  width: 100%;
              }

              .ExternalClass,
              .ExternalClass p,
              .ExternalClass span,
              .ExternalClass font,
              .ExternalClass td,
              .ExternalClass div {
                  line-height: 100%;
              }

              .es-button {
                  mso-style-priority: 100 !important;
                  text-decoration: none !important;
                  transition: all 100ms ease-in;
              }

              a[x-apple-data-detectors] {
                  color: inherit !important;
                  text-decoration: none !important;
                  font-size: inherit !important;
                  font-family: inherit !important;
                  font-weight: inherit !important;
                  line-height: inherit !important;
              }

              .es-button:hover {
                  background: #555555 !important;
                  border-color: #555555 !important;
              }

              .es-desk-hidden {
                  display: none;
                  float: left;
                  overflow: hidden;
                  width: 0;
                  max-height: 0;
                  line-height: 0;
                  mso-hide: all;
              }

              [data-ogsb] .es-button {
                  border-width: 0 !important;
                  padding: 15px 30px 15px 30px !important;
              }

              [data-ogsb] .es-button.es-button-1 {
                  padding: 15px 25px !important;
              }

              @media only screen and (max-width:600px) {

                  p,
                  ul li,
                  ol li,
                  a {
                  line-height: 150% !important
                  }

                  h1,
                  h2,
                  h3,
                  h1 a,
                  h2 a,
                  h3 a {
                  line-height: 120% !important
                  }

                  h1 {
                  font-size: 30px !important;
                  text-align: center
                  }

                  h2 {
                  font-size: 26px !important;
                  text-align: left
                  }

                  h3 {
                  font-size: 20px !important;
                  text-align: left
                  }

                  h1 a {
                  text-align: center
                  }

                  .es-header-body h1 a,
                  .es-content-body h1 a,
                  .es-footer-body h1 a {
                  font-size: 30px !important
                  }

                  h2 a {
                  text-align: left
                  }

                  .es-header-body h2 a,
                  .es-content-body h2 a,
                  .es-footer-body h2 a {
                  font-size: 20px !important
                  }

                  h3 a {
                  text-align: left
                  }

                  .es-header-body h3 a,
                  .es-content-body h3 a,
                  .es-footer-body h3 a {
                  font-size: 20px !important
                  }

                  .es-menu td a {
                  font-size: 16px !important
                  }

                  .es-header-body p,
                  .es-header-body ul li,
                  .es-header-body ol li,
                  .es-header-body a {
                  font-size: 16px !important
                  }

                  .es-content-body p,
                  .es-content-body ul li,
                  .es-content-body ol li,
                  .es-content-body a {
                  font-size: 17px !important
                  }

                  .es-footer-body p,
                  .es-footer-body ul li,
                  .es-footer-body ol li,
                  .es-footer-body a {
                  font-size: 17px !important
                  }

                  .es-infoblock p,
                  .es-infoblock ul li,
                  .es-infoblock ol li,
                  .es-infoblock a {
                  font-size: 12px !important
                  }

                  *[class="gmail-fix"] {
                  display: none !important
                  }

                  .es-m-txt-c,
                  .es-m-txt-c h1,
                  .es-m-txt-c h2,
                  .es-m-txt-c h3 {
                  text-align: center !important
                  }

                  .es-m-txt-r,
                  .es-m-txt-r h1,
                  .es-m-txt-r h2,
                  .es-m-txt-r h3 {
                  text-align: right !important
                  }

                  .es-m-txt-l,
                  .es-m-txt-l h1,
                  .es-m-txt-l h2,
                  .es-m-txt-l h3 {
                  text-align: left !important
                  }

                  .es-m-txt-r img,
                  .es-m-txt-c img,
                  .es-m-txt-l img {
                  display: inline !important
                  }

                  .es-button-border {
                  display: inline-block !important
                  }

                  a.es-button,
                  button.es-button {
                  font-size: 14px !important;
                  display: inline-block !important;
                  border-width: 15px 25px 15px 25px !important
                  }

                  .es-btn-fw {
                  border-width: 10px 0px !important;
                  text-align: center !important
                  }

                  .es-adaptive table,
                  .es-btn-fw,
                  .es-btn-fw-brdr,
                  .es-left,
                  .es-right {
                  width: 100% !important
                  }

                  .es-content table,
                  .es-header table,
                  .es-footer table,
                  .es-content,
                  .es-footer,
                  .es-header {
                  width: 100% !important;
                  max-width: 600px !important
                  }

                  .es-adapt-td {
                  display: block !important;
                  width: 100% !important
                  }

                  .adapt-img {
                  width: 100% !important;
                  height: auto !important
                  }

                  .es-m-p0 {
                  padding: 0px !important
                  }

                  .es-m-p0r {
                  padding-right: 0px !important
                  }

                  .es-m-p0l {
                  padding-left: 0px !important
                  }

                  .es-m-p0t {
                  padding-top: 0px !important
                  }

                  .es-m-p0b {
                  padding-bottom: 0 !important
                  }

                  .es-m-p20b {
                  padding-bottom: 20px !important
                  }

                  .es-mobile-hidden,
                  .es-hidden {
                  display: none !important
                  }

                  tr.es-desk-hidden,
                  td.es-desk-hidden,
                  table.es-desk-hidden {
                  width: auto !important;
                  overflow: visible !important;
                  float: none !important;
                  max-height: inherit !important;
                  line-height: inherit !important
                  }

                  tr.es-desk-hidden {
                  display: table-row !important
                  }

                  table.es-desk-hidden {
                  display: table !important
                  }

                  td.es-desk-menu-hidden {
                  display: table-cell !important
                  }

                  .es-menu td {
                  width: 1% !important
                  }

                  table.es-table-not-adapt,
                  .esd-block-html table {
                  width: auto !important
                  }

                  table.es-social {
                  display: inline-block !important
                  }

                  table.es-social td {
                  display: inline-block !important
                  }

                  .es-desk-hidden {
                  display: table-row !important;
                  width: auto !important;
                  overflow: visible !important;
                  max-height: inherit !important
                  }
              }
              </style>
          </head>
          <body style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
              <div class="es-wrapper-color" style="background-color:#F1F1F1">
              <!--[if gte mso 9]>
                                              <v:background
                                                  xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
                                                  <v:fill type="tile" color="#f1f1f1"></v:fill>
                                              </v:background>
                                              <![endif]-->
              <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
                  <tr style="border-collapse:collapse">
                  <td valign="top" style="padding:0;Margin:0">
                      <table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
                                  <!--[if mso]>
                                                                                  <table style="width:580px" cellpadding="0" cellspacing="0">
                                                                                      <tr>
                                                                                          <td style="width:282px" valign="top">
                                                                                              <![endif]-->
                                  <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:282px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px"><br>
                                              </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                              </td>
                                                                                              <td style="width:20px"></td>
                                                                                              <td style="width:278px" valign="top">
                                                                                                  <![endif]-->
                                  <table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:278px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                              <!--<p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">
                                                  <a href="${app?.url}/forgotPasswordMessage/${userId}" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">${messages?.viewInBrowser?.[languageId]}</a>
                                              </p>-->
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                              </td>
                                                                                          </tr>
                                                                                      </table>
                                                                                      <![endif]-->
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-header" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px;background-color:#333333" bgcolor="#333333" align="left">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;font-size:0">
                                              <!--<a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#FFFFFF;font-size:14px">-->
                                              <a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px">
                                              <!--<img src="https://vlckba.stripocdn.email/content/guids/CABINET_85e4431b39e3c4492fca561009cef9b5/images/51621521206431413.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="57">-->
                                              <h3 style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:15px;font-style:normal;font-weight:bold;color:#ffffff">${appData?.title}</h3>
                                              </a>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#333333;width:600px" cellspacing="0" cellpadding="0" bgcolor="#333333" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px;background-image:url('${images?.img001}');background-repeat:no-repeat" align="left" background="${images?.img001}">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px;padding-top:40px">
                                              <h1 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#ffffff">${labels?.hello?.[languageId]} ${fullName}</h1>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td esdev-links-color="#757575" align="center" style="Margin:0;padding-top:10px;padding-bottom:20px;padding-left:30px;padding-right:30px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#757575;font-size:15px">${messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageId]}.</p>
                                          </td>
                                          </tr>
                                          <!--<tr style="border-collapse:collapse">
                                              <td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:20px">
                                                  <span class="es-button-border" style="border-style:solid;border-color:#26a4d3;background:none 0% 0% repeat scroll #26a4d3;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                  <a href="${app?.url}${backend?.urlLogin}" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;border-style:solid;border-color:#26a4d3;border-width:15px 30px 15px 30px;display:inline-block;background:#26a4d3;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${labels?.accessAccount?.[languageId]}</a>
                                                  </span>
                                              </td>
                                          </tr>-->
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="padding:0;Margin:0;padding-top:40px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-m-txt-c" align="left" style="padding:0;Margin:0;padding-top:5px;padding-bottom:15px">
                                              <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#333333">${messages?.youHaveRequestedToResetYourPassword?.[languageId]}</h2>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                              <td align="left" style="padding:0;Margin:0;padding-bottom:10px">
                                                  <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                      ${messages?.restorePasswordMessage01?.[languageId]}.
                                                  </p>
                                              </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                              <td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:20px">
                                                  <span class="es-button-border" style="border-style:solid;border-color:#26a4d3;background:none 0% 0% repeat scroll #26a4d3;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                  <a href="${urlForgotPassword}" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;border-style:solid;border-color:#26a4d3;border-width:15px 30px 15px 30px;display:inline-block;background:#26a4d3;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${labels?.restorePassword?.[languageId]}</a>
                                                  </span>
                                              </td>
                                          </tr>

                                          <tr style="border-collapse:collapse">
                                              <td align="left" style="padding:0;Margin:0;padding-bottom:10px">
                                                  <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                      ${messages?.ifForAnyReasonThisEmailWasSentIncorrectly?.[languageId]}:<br/>
                                                      - ${messages?.itWasNotYouWhoRequestedThePasswordChange?.[languageId]}<br/>
                                                      - ${messages?.suspectedElectronicIdentityTheft?.[languageId]}<br/>
                                                      - ${messages?.youSuspectThatTheyWantToEnterOurWebSystemWithYourCredentials?.[languageId]}<br/><br/>
                                                      ${messages?.forwardThisEmailAgainImmediatelyToTheFollowingAddress?.[languageId]}:
                                                      <a href='mailto:${app?.users?.admin2?.email}?subject=${messages?.contactTheSupportDepartment?.[languageId]}'>
                                                          <b>${labels?.supportDepartment?.[languageId]}</b>
                                                      </a> 
                                                      ${messages?.toPreventUnwantedAccessToOurWebSystemWithYourCredentials?.[languageId]}.
                                                  </p>
                                              </td>
                                          </tr>

                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${welcomenMessage02Get({ languageId: languageId, subMethod: currentMethod, })?.result}. <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${labels?.yoursSincerely?.[languageId]},</p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:10px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                  <!--[if mso]>
                                                                                              <table style="width:520px" cellpadding="0"
                                      cellspacing="0">
                                                                                                  <tr>
                                                                                                      <td style="width:40px" valign="top">
                                                                                                          <![endif]-->
                                  <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                  <tr style="border-collapse:collapse">
                                      <td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:40px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;font-size:0">
                                              <img src="${images?.img002}" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="50">
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                                          </td>
                                                                                                          <td style="width:20px"></td>
                                                                                                          <td style="width:460px" valign="top">
                                                                                                              <![endif]-->
                                  <table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:460px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#222222;font-size:14px">
                                              <strong>${app?.ceo}</strong>
                                              <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#666666;font-size:14px">CEO | ${appData?.title}</p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                                              </td>
                                                                                                          </tr>
                                                                                                      </table>
                                                                                                      <![endif]-->
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#26a4d3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#26a4d3" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-bottom:20px;padding-top:40px;padding-left:40px;padding-right:40px;background-color:#26a4d3" bgcolor="#26a4d3" align="left">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-m-txt-c" align="center" style="padding:0;Margin:0">
                                              <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#ffffff">${messages?.yourFeedbackIsImportant?.[languageId]} <br>
                                              </h2>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-top:5px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:26px;color:#aad4ea;font-size:17px">${messages?.letUsKnowWhatYouThinkOfOurLatestUpdates?.[languageId]} <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:10px;Margin:0">
                                              <span class="es-button-border" style="border-style:solid;border-color:#26A4D3;background:#ffffff;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                              <a href="${app?.url}${backend?.urlContact}" class="es-button es-button-1" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#26a4d3;font-size:14px;border-style:solid;border-color:#ffffff;border-width:15px 25px;display:inline-block;background:#ffffff;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${messages?.giveFeedback?.[languageId]}</a>
                                              </span>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#292828;width:600px" cellspacing="0" cellpadding="0" bgcolor="#292828" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;font-size:0">
                                              <table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                              <tr style="border-collapse:collapse">
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.facebook}' target='_blank'>
                                                          <img title="Facebook" src="${images?.facebook}" alt="Fb" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.twitter}' target='_blank'>
                                                          <img title="Twitter" src="${images?.twitter}" alt="Tw" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.instagram}' target='_blank'>
                                                          <img title="Instagram" src="${images?.instagram}" alt="Inst" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0">
                                                      <a href='${urls?.linkedin}' target='_blank'>
                                                          <img title="Linkedin" src="${images?.linkedin}" alt="In" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                              </tr>
                                              </table>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-footer" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-footer-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${appData?.address}</p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${messages?.thisEmailWasSentToYouFrom?.[languageId]} ${appData?.email}</p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">
                                              <a target="_blank" href="${app?.url}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.home?.[languageId]}</a> | <a target="_blank" href="${app?.url}/about" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.about?.[languageId]}</a> | <a target="_blank" href="${app?.url}${backend?.urlContact}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.contact?.[languageId]}</a> | <a target="_blank" class="unsubscribe" href="${app?.url}/privacy" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.privacy?.[languageId]}</a>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">Copyright © ${appData?.year} <strong>${appData?.title}</strong>, All Rights Reserved. </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:560px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-infoblock made_with" align="center" style="padding:0;Margin:0;line-height:120%;font-size:0;color:#CCCCCC">
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                  </td>
                  </tr>
              </table>
              </div>
          </body>
          </html>`;
    //#endregion get html file
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}

export const contactMessageEmailBodyGet = ({
  id = '',
  name = '',
  email = '',
  subject = '',
  message = '',
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'contactMessageEmailBodyGet';
  let response = responseGet();
  try {
    //#region variables
    const fullName = name;
    //#endregion variables

    //#region get html file
    response.result = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
          <html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
          <head>
              <meta charset="UTF-8">
              <meta content="width=device-width, initial-scale=1" name="viewport">
              <meta name="x-apple-disable-message-reformatting">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta content="telephone=no" name="format-detection">
              <title>New email template 2022-06-24</title>
              <!--[if (mso 16)]>
                                      <style type="text/css">
              a {text-decoration: none;}
              </style>
                                      <![endif]-->
              <!--[if gte mso 9]>
                                      <style>sup { font-size: 100% !important; }</style>
                                      <![endif]-->
              <!--[if gte mso 9]>
                                      <xml>
                                          <o:OfficeDocumentSettings>
                                              <o:AllowPNG></o:AllowPNG>
                                              <o:PixelsPerInch>96</o:PixelsPerInch>
                                          </o:OfficeDocumentSettings>
                                      </xml>
                                      <![endif]-->
              <!--[if !mso]>
                                      <!-- -->
              <link href="https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i" rel="stylesheet">
              <!--
                                          <![endif]-->
              <style type="text/css">
              #outlook a {
                  padding: 0;
              }

              .ExternalClass {
                  width: 100%;
              }

              .ExternalClass,
              .ExternalClass p,
              .ExternalClass span,
              .ExternalClass font,
              .ExternalClass td,
              .ExternalClass div {
                  line-height: 100%;
              }

              .es-button {
                  mso-style-priority: 100 !important;
                  text-decoration: none !important;
                  transition: all 100ms ease-in;
              }

              a[x-apple-data-detectors] {
                  color: inherit !important;
                  text-decoration: none !important;
                  font-size: inherit !important;
                  font-family: inherit !important;
                  font-weight: inherit !important;
                  line-height: inherit !important;
              }

              .es-button:hover {
                  background: #555555 !important;
                  border-color: #555555 !important;
              }

              .es-desk-hidden {
                  display: none;
                  float: left;
                  overflow: hidden;
                  width: 0;
                  max-height: 0;
                  line-height: 0;
                  mso-hide: all;
              }

              [data-ogsb] .es-button {
                  border-width: 0 !important;
                  padding: 15px 30px 15px 30px !important;
              }

              [data-ogsb] .es-button.es-button-1 {
                  padding: 15px 25px !important;
              }

              @media only screen and (max-width:600px) {

                  p,
                  ul li,
                  ol li,
                  a {
                  line-height: 150% !important
                  }

                  h1,
                  h2,
                  h3,
                  h1 a,
                  h2 a,
                  h3 a {
                  line-height: 120% !important
                  }

                  h1 {
                  font-size: 30px !important;
                  text-align: center
                  }

                  h2 {
                  font-size: 26px !important;
                  text-align: left
                  }

                  h3 {
                  font-size: 20px !important;
                  text-align: left
                  }

                  h1 a {
                  text-align: center
                  }

                  .es-header-body h1 a,
                  .es-content-body h1 a,
                  .es-footer-body h1 a {
                  font-size: 30px !important
                  }

                  h2 a {
                  text-align: left
                  }

                  .es-header-body h2 a,
                  .es-content-body h2 a,
                  .es-footer-body h2 a {
                  font-size: 20px !important
                  }

                  h3 a {
                  text-align: left
                  }

                  .es-header-body h3 a,
                  .es-content-body h3 a,
                  .es-footer-body h3 a {
                  font-size: 20px !important
                  }

                  .es-menu td a {
                  font-size: 16px !important
                  }

                  .es-header-body p,
                  .es-header-body ul li,
                  .es-header-body ol li,
                  .es-header-body a {
                  font-size: 16px !important
                  }

                  .es-content-body p,
                  .es-content-body ul li,
                  .es-content-body ol li,
                  .es-content-body a {
                  font-size: 17px !important
                  }

                  .es-footer-body p,
                  .es-footer-body ul li,
                  .es-footer-body ol li,
                  .es-footer-body a {
                  font-size: 17px !important
                  }

                  .es-infoblock p,
                  .es-infoblock ul li,
                  .es-infoblock ol li,
                  .es-infoblock a {
                  font-size: 12px !important
                  }

                  *[class="gmail-fix"] {
                  display: none !important
                  }

                  .es-m-txt-c,
                  .es-m-txt-c h1,
                  .es-m-txt-c h2,
                  .es-m-txt-c h3 {
                  text-align: center !important
                  }

                  .es-m-txt-r,
                  .es-m-txt-r h1,
                  .es-m-txt-r h2,
                  .es-m-txt-r h3 {
                  text-align: right !important
                  }

                  .es-m-txt-l,
                  .es-m-txt-l h1,
                  .es-m-txt-l h2,
                  .es-m-txt-l h3 {
                  text-align: left !important
                  }

                  .es-m-txt-r img,
                  .es-m-txt-c img,
                  .es-m-txt-l img {
                  display: inline !important
                  }

                  .es-button-border {
                  display: inline-block !important
                  }

                  a.es-button,
                  button.es-button {
                  font-size: 14px !important;
                  display: inline-block !important;
                  border-width: 15px 25px 15px 25px !important
                  }

                  .es-btn-fw {
                  border-width: 10px 0px !important;
                  text-align: center !important
                  }

                  .es-adaptive table,
                  .es-btn-fw,
                  .es-btn-fw-brdr,
                  .es-left,
                  .es-right {
                  width: 100% !important
                  }

                  .es-content table,
                  .es-header table,
                  .es-footer table,
                  .es-content,
                  .es-footer,
                  .es-header {
                  width: 100% !important;
                  max-width: 600px !important
                  }

                  .es-adapt-td {
                  display: block !important;
                  width: 100% !important
                  }

                  .adapt-img {
                  width: 100% !important;
                  height: auto !important
                  }

                  .es-m-p0 {
                  padding: 0px !important
                  }

                  .es-m-p0r {
                  padding-right: 0px !important
                  }

                  .es-m-p0l {
                  padding-left: 0px !important
                  }

                  .es-m-p0t {
                  padding-top: 0px !important
                  }

                  .es-m-p0b {
                  padding-bottom: 0 !important
                  }

                  .es-m-p20b {
                  padding-bottom: 20px !important
                  }

                  .es-mobile-hidden,
                  .es-hidden {
                  display: none !important
                  }

                  tr.es-desk-hidden,
                  td.es-desk-hidden,
                  table.es-desk-hidden {
                  width: auto !important;
                  overflow: visible !important;
                  float: none !important;
                  max-height: inherit !important;
                  line-height: inherit !important
                  }

                  tr.es-desk-hidden {
                  display: table-row !important
                  }

                  table.es-desk-hidden {
                  display: table !important
                  }

                  td.es-desk-menu-hidden {
                  display: table-cell !important
                  }

                  .es-menu td {
                  width: 1% !important
                  }

                  table.es-table-not-adapt,
                  .esd-block-html table {
                  width: auto !important
                  }

                  table.es-social {
                  display: inline-block !important
                  }

                  table.es-social td {
                  display: inline-block !important
                  }

                  .es-desk-hidden {
                  display: table-row !important;
                  width: auto !important;
                  overflow: visible !important;
                  max-height: inherit !important
                  }
              }
              </style>
          </head>
          <body style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
              <div class="es-wrapper-color" style="background-color:#F1F1F1">
              <!--[if gte mso 9]>
                                              <v:background
                                                  xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
                                                  <v:fill type="tile" color="#f1f1f1"></v:fill>
                                              </v:background>
                                              <![endif]-->
              <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
                  <tr style="border-collapse:collapse">
                  <td valign="top" style="padding:0;Margin:0">
                      <table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
                                  <!--[if mso]>
                                                                                  <table style="width:580px" cellpadding="0" cellspacing="0">
                                                                                      <tr>
                                                                                          <td style="width:282px" valign="top">
                                                                                              <![endif]-->
                                  <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:282px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px"><br>
                                              </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                              </td>
                                                                                              <td style="width:20px"></td>
                                                                                              <td style="width:278px" valign="top">
                                                                                                  <![endif]-->
                                  <table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:278px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                            <!--<td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC">
                                                <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">
                                                    <a href="${app?.url}${backend?.urlContactMessages}/${id}" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">${messages?.viewInBrowser?.[languageId]}</a>
                                                </p>
                                            </td>-->
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                              </td>
                                                                                          </tr>
                                                                                      </table>
                                                                                      <![endif]-->
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-header" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px;background-color:#333333" bgcolor="#333333" align="left">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;font-size:0">
                                              <!--<a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#FFFFFF;font-size:14px">-->
                                              <a href="${app?.url}" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px">
                                              <!--<img src="https://vlckba.stripocdn.email/content/guids/CABINET_85e4431b39e3c4492fca561009cef9b5/images/51621521206431413.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="57">-->
                                              <h3 style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:15px;font-style:normal;font-weight:bold;color:#ffffff">${appData?.title}</h3>
                                              </a>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#333333;width:600px" cellspacing="0" cellpadding="0" bgcolor="#333333" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px;background-image:url('${images?.img001}');background-repeat:no-repeat" align="left" background="${images?.img001}">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px;padding-top:40px">
                                              <h1 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#ffffff">${labels?.hello?.[languageId]} ${fullName}</h1>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td esdev-links-color="#757575" align="center" style="Margin:0;padding-top:10px;padding-bottom:20px;padding-left:30px;padding-right:30px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#757575;font-size:15px">${messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageId]}.</p>
                                          </td>
                                          </tr>
                                          <!--<tr style="border-collapse:collapse">
                                              <td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:20px">
                                                  <span class="es-button-border" style="border-style:solid;border-color:#26a4d3;background:none 0% 0% repeat scroll #26a4d3;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                                  <a href="${app?.url}${backend?.urlLogin}" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;border-style:solid;border-color:#26a4d3;border-width:15px 30px 15px 30px;display:inline-block;background:#26a4d3;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${labels?.accessAccount?.[languageId]}</a>
                                                  </span>
                                              </td>
                                          </tr>-->
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="padding:0;Margin:0;padding-top:40px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-m-txt-c" align="left" style="padding:0;Margin:0;padding-top:5px;padding-bottom:15px">
                                              <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#333333">${messages?.YourMessageHasBeenSent?.[languageId]}</h2>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                              <td align="left" style="padding:0;Margin:0;padding-bottom:10px">
                                                  <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                      ${messages?.contactMessage001?.[languageId]}.
                                                  </p>
                                              </td>
                                          </tr>
                                                                                     
                                          <tr style="border-collapse:collapse">
                                              <td align="left" style="padding:0;Margin:0;padding-bottom:10px">
                                                  <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                      ${messages?.contactMessage002?.[languageId]}:<br/>
                                                      - <b>${labels?.name?.[languageId]}</b>: ${name}<br/>
                                                      - <b>${labels?.email?.[languageId]}</b>: ${email}<br/>
                                                      - <b>${labels?.subject?.[languageId]}</b>: ${subject}<br/>
                                                      - <b>${labels?.message?.[languageId]}</b>: ${message}<br/>
                                                  </p>
                                              </td>
                                          </tr>

                                          <tr style="border-collapse:collapse">
                                              <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                                  <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">
                                                      ${welcomenMessage02Get({ languageId: languageId, subMethod: currentMethod, })?.result}. <br>
                                                  </p>
                                              </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                              <td align="left" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px">
                                                  <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:23px;color:#555555;font-size:15px">${labels?.yoursSincerely?.[languageId]},</p>
                                              </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:10px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                  <!--[if mso]>
                                                                                              <table style="width:520px" cellpadding="0"
                                      cellspacing="0">
                                                                                                  <tr>
                                                                                                      <td style="width:40px" valign="top">
                                                                                                          <![endif]-->
                                  <table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                                  <tr style="border-collapse:collapse">
                                      <td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:40px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;font-size:0">
                                              <img src="${images?.img002}" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="50">
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                                          </td>
                                                                                                          <td style="width:20px"></td>
                                                                                                          <td style="width:460px" valign="top">
                                                                                                              <![endif]-->
                                  <table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td align="left" style="padding:0;Margin:0;width:460px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0;padding-top:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#222222;font-size:14px">
                                              <strong>${app?.ceo}</strong>
                                              <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="left" style="padding:0;Margin:0">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:21px;color:#666666;font-size:14px">CEO | ${appData?.title}</p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                                  <!--[if mso]>
                                                                                                              </td>
                                                                                                          </tr>
                                                                                                      </table>
                                                                                                      <![endif]-->
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#26a4d3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#26a4d3" align="center">
                              <tr style="border-collapse:collapse">
                              <td style="Margin:0;padding-bottom:20px;padding-top:40px;padding-left:40px;padding-right:40px;background-color:#26a4d3" bgcolor="#26a4d3" align="left">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-m-txt-c" align="center" style="padding:0;Margin:0">
                                              <h2 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:bold;color:#ffffff">${messages?.yourFeedbackIsImportant?.[languageId]} <br>
                                              </h2>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-top:5px;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:26px;color:#aad4ea;font-size:17px">${messages?.letUsKnowWhatYouThinkOfOurLatestUpdates?.[languageId]} <br>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:10px;Margin:0">
                                              <span class="es-button-border" style="border-style:solid;border-color:#26A4D3;background:#ffffff;border-width:0px;display:inline-block;border-radius:50px;width:auto">
                                              <a href="${app?.url}${backend?.urlContact}" class="es-button es-button-1" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;transition:all 100ms ease-in;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#26a4d3;font-size:14px;border-style:solid;border-color:#ffffff;border-width:15px 25px;display:inline-block;background:#ffffff;border-radius:50px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">${messages?.giveFeedback?.[languageId]}</a>
                                              </span>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#292828;width:600px" cellspacing="0" cellpadding="0" bgcolor="#292828" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:30px;padding-bottom:30px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;font-size:0">
                                              <table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                              <tr style="border-collapse:collapse">
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.facebook}' target='_blank'>
                                                          <img title="Facebook" src="${images?.facebook}" alt="Fb" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.twitter}' target='_blank'>
                                                          <img title="Twitter" src="${images?.twitter}" alt="Tw" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px">
                                                      <a href='${urls?.instagram}' target='_blank'>
                                                          <img title="Instagram" src="${images?.instagram}" alt="Inst" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                                  <td valign="top" align="center" style="padding:0;Margin:0">
                                                      <a href='${urls?.linkedin}' target='_blank'>
                                                          <img title="Linkedin" src="${images?.linkedin}" alt="In" width="24" height="24" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
                                                      </a>
                                                  </td>
                                              </tr>
                                              </table>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table cellpadding="0" cellspacing="0" class="es-footer" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-footer-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#ffffff;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-top:40px;padding-bottom:40px;padding-left:40px;padding-right:40px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:520px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${appData?.address}</p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">${messages?.thisEmailWasSentToYouFrom?.[languageId]} ${appData?.email}</p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0;padding-bottom:10px">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">
                                              <a target="_blank" href="${app?.url}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.home?.[languageId]}</a> | <a target="_blank" href="${app?.url}/about" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.about?.[languageId]}</a> | <a target="_blank" href="${app?.url}${backend?.urlContact}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.contact?.[languageId]}</a> | <a target="_blank" class="unsubscribe" href="${app?.url}/privacy" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#666666;font-size:12px">${labels?.privacy?.[languageId]}</a>
                                              </p>
                                          </td>
                                          </tr>
                                          <tr style="border-collapse:collapse">
                                          <td align="center" style="padding:0;Margin:0">
                                              <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">Copyright © ${appData?.year} <strong>${appData?.title}</strong>, All Rights Reserved. </p>
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                      <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                      <tr style="border-collapse:collapse">
                          <td align="center" style="padding:0;Margin:0">
                          <table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
                              <tr style="border-collapse:collapse">
                              <td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
                                  <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                  <tr style="border-collapse:collapse">
                                      <td valign="top" align="center" style="padding:0;Margin:0;width:560px">
                                      <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                          <tr style="border-collapse:collapse">
                                          <td class="es-infoblock made_with" align="center" style="padding:0;Margin:0;line-height:120%;font-size:0;color:#CCCCCC">
                                          </td>
                                          </tr>
                                      </table>
                                      </td>
                                  </tr>
                                  </table>
                              </td>
                              </tr>
                          </table>
                          </td>
                      </tr>
                      </table>
                  </td>
                  </tr>
              </table>
              </div>
          </body>
          </html>`;
    //#endregion get html file
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex?.message}`;
  }
  return response;
}